import * as Sentry from "@sentry/react";

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  
  if (!dsn) {
    console.info("Sentry DSN not configured - error tracking disabled");
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    
    // Performance monitoring - sample 10% of transactions
    tracesSampleRate: 0.1,
    
    // Only enable in production
    enabled: import.meta.env.PROD,
    
    // Filter out non-critical errors
    beforeSend(event) {
      // Don't send errors in development
      if (import.meta.env.DEV) return null;
      return event;
    },
    
    // Exclude Supabase from Sentry's fetch tracing to prevent header interference
    tracePropagationTargets: ["localhost", /^\/(?!.*supabase)/],

    // Integrations for browser tracing and session replay
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    
    // Session replay: none by default, 100% on error
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

export { Sentry };
